import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const TransformSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-gradient-to-r from-blue-600 to-blue-500 text-white">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6">
          Ready to Transform Your Operations?
        </h2>
        <p className="text-lg md:text-xl opacity-90 mb-8 md:mb-10">
          Join 500+ CEOs and CFOs who have already solved these challenges with ZippyAssist's Extended Operations Partnership
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100">
            <Icon name="Calendar" size={18} className="mr-2" />
            Schedule Executive Consultation
          </Button>
          <Button size="lg" variant="outline" className="bg-transparent border-2 border-white text-white hover:bg-white/10">
            <Icon name="Download" size={18} className="mr-2" />
            Download Case Studies
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TransformSection;